import PositionPref from "../../enums/position-pref";
import FootballState from "../../state/football-state";
import Pref from "./position-pref";

export default class ReturnedByPositionPref extends Pref {
    constructor(play, fragment) {
        super(play, fragment);
    }

    resolve() {
        if (this.play.historyContains(FootballState.KickOff)) {
            return PositionPref.RETURNER_KICKOFF;
        }
        if (this.play.historyContains(FootballState.Punt)) {
            return PositionPref.RETURNER_PUNT;
        }
    }
}
